
export const getProducts = () => {
  try {
    const stored = localStorage.getItem('quotation_products');
    if (stored) {
      const parsed = JSON.parse(stored);
      const defaultProducts = getDefaultProducts();
      const productMap = new Map();
      
      defaultProducts.forEach(p => {
        productMap.set(p.name.toLowerCase(), p);
      });
      
      parsed.forEach(p => {
        productMap.set(p.name.toLowerCase(), p);
      });
      
      return Array.from(productMap.values());
    }
  } catch (error) {
    console.error('Error loading products from localStorage:', error);
  }
  return getDefaultProducts();
};

export const addProduct = (productName, hsn, unit = 'Mtr') => {
  try {
    const products = getProducts();
    const productExists = products.some(p => p.name.toLowerCase() === productName.toLowerCase());
    
    if (!productExists) {
      const newProduct = {
        name: productName,
        hsn: hsn || '',
        defaultUnit: unit
      };
      products.push(newProduct);
      localStorage.setItem('quotation_products', JSON.stringify(products));
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error saving product:', error);
    return false;
  }
};

const getDefaultProducts = () => [
  { name: 'AB CABLE 3CX16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX35+16+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX+70+16+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX+95+16+70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX+120+16+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX120 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX25+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX35+16+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX+70+16+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX+95+16+70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX+120+16+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX120 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX35+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX+70+16+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX+95+16+70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX+120+16+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC Mole 15 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Squirrel 22 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Weasel 34 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Rabbit 56 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Raccoon 80 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Dog-up 125 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Coyote 148 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Wolf 173 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Wolf-up 200 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Panther 232 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Panther-up1 288 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Panther-up2 346 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Kundan 400 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Zebra 455 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Zebra-up 525 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Moose 570 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Morkulia 604 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Moose-up 642 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Morkula-up 960 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'AAAC Bersimis 767 SQMM', hsn: '85446090', defaultUnit: 'Mtr' },
  { name: 'DPC 0.85', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.06', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.25', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.32', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.4', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.5', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.6', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.7', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.8', hsn: '', defaultUnit: 'Mtr' },
  { name: 'DPC 1.9', hsn: '', defaultUnit: 'Mtr' },
  { name: 'SUBMERSIBLE CABLE 3CX6 SQMM', hsn: '85446020', defaultUnit: 'Mtr' },
  { name: 'EARTHING CABLE 2.5 SQMM', hsn: '85441990', defaultUnit: 'Mtr' },
  { name: '1CX2.5 SQMM ALUMINIUM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ARMOURED 2CX10 SQMM', hsn: '8544499', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+16+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX35+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+16+35 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2CX10 SQMM ARMOURED CABLE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'EARTHIN WIRE 3.15 MM', hsn: '85441', defaultUnit: 'Mtr' },
  { name: '1CX1.50 SQMM', hsn: '76051100', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC RACCOON CONDUCTOR', hsn: '854411', defaultUnit: 'Mtr' },
  { name: 'LT AB CABLE 3CX50+16+35 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX35+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+16+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'PVC INSULATED ALUMINIUM 2 C FLAT', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'PVC INSULATED ALUMINIUM 7STAND', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'PVC INSULATED ALUMINIUM 1 CORE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ANOCAB 1C SS AL 10 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: '2.65 MM ALUMINIUM WIRE', hsn: '85441110', defaultUnit: 'Kg' },
  { name: '2.43 MM ALUMINIUM WIRE', hsn: '85441110', defaultUnit: 'Kg' },
  { name: '2.95 MM ALUMINIUM WIRE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ACSR Panther Conductor', hsn: '76042910', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX16+25', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX16+16', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'Aluminium Wire EC Grade – 1mm', hsn: '4581110', defaultUnit: 'Kg' },
  { name: 'ALUMINIUM Wire Commercial Grade – 1mm', hsn: '4581110', defaultUnit: 'Kg' },
  { name: 'AB CABLE 3CX70+16+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR COYOTE', hsn: '76141000', defaultUnit: 'Mtr' },
  { name: 'ACSR ZEBRA CONDUCTOR', hsn: '76141000', defaultUnit: 'Mtr' },
  { name: 'ACSR Dog Conductor', hsn: '76042910', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX150 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '3CX95+16+50 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX35+16+35 SQMM AL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '3CX16+16+16 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX150 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+50 SQMM ALL INSULATED DOUBLE COATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+50 SQMM ALL INSULATED DOUBLE COATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'Aluminum 1CX99 SQMM. Covered Conductor', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ANOCAB 1.1 KV 1.0 SQMM IS : 694 CML/N 8200128908', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX16+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX150+35+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX150+35+95 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+50 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+70 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16+25 SQMM DOUBLE COATED BAER MESSAGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX70 SQMM Covered Conductor', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX300 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX100 SQMM COVERED CONDUCTOR', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25+16 SQMM DOUBLE COATED BAER MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'LOCAL 1C AL 7S 6 SQMM 90 MTR', hsn: '854411101', defaultUnit: 'Mtr' },
  { name: 'ANOCAB 3CX2.5 SQMM SUBMERSIBLE CABLE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ACSR Moose Conductor', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: '1.00 MM ALUMINIUM WIRE', hsn: '8544', defaultUnit: 'Kg' },
  { name: 'ACSR WOLF CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX16+16  SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16+35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX150+25+95 SQ MM DOUBLE COATED ALL COVERED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+70 SQ MM DOUBLE COATED ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+70 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR RABBIT Conductor', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ANOCAB ALUMINIUM SINGLE CORE 16 SQMM 270 MTR', hsn: '8544', defaultUnit: 'PCS' },
  { name: 'ANOCAB ALUMINIUM SINGLE CORE 10 SQMM 270 MTR', hsn: '8544', defaultUnit: 'PCS' },
  { name: 'AB CABLE 3CX25+25 SQMM BAER MASSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '98 NO', hsn: '8544', defaultUnit: 'Kg' },
  { name: '127 NO', hsn: '8544', defaultUnit: 'Kg' },
  { name: 'AB CABLE 3CX25+16+35 SQMM DOUBLE COATED BAER MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ANOCAB MULTISTRAND SINGLE CORE PVC INSUATED COPPER WIRE 1.5 SQMM 90MTR', hsn: '8544', defaultUnit: 'PCS' },
  { name: 'ANOCAB MULTISTRAND SINGLE CORE PVC INSUATED COPPER WIRE 1.0 SQMM 90MTR', hsn: '8544', defaultUnit: 'PCS' },
  { name: 'COVERED CONDUCTOR 1CX300 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'COVERED CONDUCTOR 1CX150 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 1CX16+25', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2XC35+35 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+16+35 SQMM AL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC DOG CONDUCTOR 100 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AAAC RACCOON CONDUCTOR 80 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AAAC WEASEL CONDUCTOR 34 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AAAC RABBIT CONDUCTOR 55 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'CONTROL CABLE - REPAIR', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ALUMINIUM WIRE 1.00 MM', hsn: '85441110', defaultUnit: 'Kg' },
  { name: 'ALUMINIUM WIRE 0.8 MM', hsn: '85441110', defaultUnit: 'Kg' },
  { name: 'AB CABLE 2CX35+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ANOCAB PVC INSULATED 3CX35 SQMM SUBMERSIBLE CABLE', hsn: '85441', defaultUnit: 'Mtr' },
  { name: 'COVERED CONDUCTOR 1CX70 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'COVERED CONDUCTOR 80 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: '4CX50 SQMM AYFY CABLE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ANOCAB 1C 7S AL 6 SQMM 90 MTR', hsn: '85441110', defaultUnit: 'PCS' },
  { name: 'ANOCAB 1C SS AL 6 SQMM 270 MTR', hsn: '85441110', defaultUnit: 'PCS' },
  { name: 'ANOCAB 1C SS AL 6 SQMM 90 MTR', hsn: '85441110', defaultUnit: 'PCS' },
  { name: 'ANOCAB 1C SS AL 6 SQMM', hsn: '85441110', defaultUnit: 'PCS' },
  { name: 'AB CABLE 3CX70+16+50 SQMM AL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX16+16 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX10+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16+35 SQMM DOUBLE COATED BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25+16 SQMM DOUBLE COATED BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC O5 CONDUCTOR', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AAAC O2 CONDUCTOR', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: '1CX35 SQMM INSULATED CABLE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: '1CX70 SQMMM INSULATED CABLE', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ALUMINIUM STRANDED CONDUCTOR 7 SQMM', hsn: '8544', defaultUnit: 'Kg' },
  { name: 'SINGLE CORE 70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'SINGLE CORE 50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'SINGLE CORE 35 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX 95+70 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+70 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX25+16 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX34 SQMM COVERED CONDUCTOR', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'ACSR DOG COVERED CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+25+95 ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+25+95', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+50 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ANNEALED ALUMINUM STRANDED CONDUCTOR (45/0.45 mm)', hsn: '8544', defaultUnit: 'Kg' },
  { name: '2C10 SQMM FLAT AL CABLE', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2C10 SQMM ROUND AL CABLE', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC DOG COVERED CONDUCTOR 100 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2CX25+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2CX35+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2CX6 SQMM ARMOURED CABLE', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'LOCAL ARMOURED 2C X 10SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'SINGLE CORE ALUMINIUM 10 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'SINGLE CORE ALUMINIUM 8 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX 35+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX35+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+16+50 SQMM DOUBLE COTED ALL INSULATION', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR WEASAL CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+70 ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+95 ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX 25+16 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+25+95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+70 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX50 SQMM Covered Conductor', hsn: '7614', defaultUnit: 'Mtr' },
  { name: 'ACSR COVERED CONDUCTOR 70 SQMM', hsn: '7614', defaultUnit: 'Mtr' },
  { name: 'ACSR COVERED CONDUCTOR 50 SQMM', hsn: '7614', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+70 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 40 SQMM', hsn: '8544', defaultUnit: 'Kg' },
  { name: 'AAAC 50 SQMM', hsn: '8455', defaultUnit: 'Kg' },
  { name: 'AB CABLE 2CX25+16 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+16+50 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'COVERED CONDUCTOR 70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+16+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR SQIRREL', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR COYOTE CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 55 SQMM COVERED CONDUTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR 25 SQMM COVERED CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 70 SQMM COVERED CONDUCTOR', hsn: '85544110', defaultUnit: 'Mtr' },
  { name: 'AAAC 70SQMM COVERED CONDUCTOR', hsn: '8544110', defaultUnit: 'Mtr' },
  { name: 'AAAC 70 SQMM', hsn: '85441110', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+35 SQMMM BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX50+16+35 SQMM BARE MESSSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 80 SQMM COVERED CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX95 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX 150 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '1CX 70 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX95+16+50 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+25+50 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '2CX25+25 SQMM BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 2CX25+25 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX90+16+50 SQMM BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX70+25+50 SQMM BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: '3CX50+16+35 SQMM BARE MESSENGER', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 04 CONDUCTOR', hsn: '84551110', defaultUnit: 'Mtr' },
  { name: 'ACSR WOLF CONDUCTOR 150 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'ACSR RACCOON CONDUCTOR 80 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AAAC 50 SQMM COVERED CONDUCTOR', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+120 SQMM ALL INSULATED', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+120 SQMM', hsn: '8544', defaultUnit: 'Mtr' },
  { name: 'AB CABLE 3CX120+120 SQMM BARE MASSANGER', hsn: '8544', defaultUnit: 'Mtr' }
];

// Available units
export const UNITS = ['Nos', 'Mtr', 'Kg', 'Set', 'PCS'];

